// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeNotificationSettingsSetTeamAlertBody = {
  teamId: string;
  alertKindKey: "gameStart" | "gameEnd";
  isEnabled: boolean;
};

export type typeNotificationSettingsSetTeamAlertOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    teamId: string;
    alertKindKey: "gameStart" | "gameEnd";
    isEnabled: boolean;
  };
};

export type typeNotificationSettingsSetTeamAlertOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeNotificationSettingsSetTeamAlertOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeNotificationSettingsSetTeamAlertOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaNotificationSettingsSetTeamAlertBody = {
  type: "object",
  properties: {
    teamId: { type: "string", maxLength: 3000, minLength: 1 },
    alertKindKey: { type: "string", enum: ["gameStart", "gameEnd"] },
    isEnabled: { type: "boolean" },
  },
  required: ["teamId", "alertKindKey", "isEnabled"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createNotificationSettingsSetTeamAlert(
  options: SdkOptions,
) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaNotificationSettingsSetTeamAlertBody);
  }

  return async function postNotificationSettingsSetTeamAlert(
    payload: typeNotificationSettingsSetTeamAlertBody,
  ): Promise<
    | typeNotificationSettingsSetTeamAlertOutput200
    | typeNotificationSettingsSetTeamAlertOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postNotificationSettingsSetTeamAlert" failed before calling the network. #18a01fc4aa5d`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#18a01fc4aa5d" },
        },
        data: null,
      } as typeNotificationSettingsSetTeamAlertOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/notification-settings/set-team-alert`,
      httpMethod: "POST",
      options,
    })) as
      | typeNotificationSettingsSetTeamAlertOutput200
      | typeNotificationSettingsSetTeamAlertOutput400;
  };
}
